var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('header-component'),_c('shop-cart-component'),_c('router-view'),_c('footer-component'),_c('login-modal-component'),_c('registration-modal-component'),_c('checkout-modal-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }